module.exports = __webpack_public_path__ + "/img/open-squirrel.83998c58ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/open-squirrel.svg
// module id = 328
// module chunks = 0